import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { AssetTitleAndDescriptionContainer } from "~/components/AssetModal/shared/components/InfoPanel/components/AssetTitleAndDescription/AssetTitleAndDescriptionContainer";
import { InfoPanelDescription } from "~/components/AssetModal/shared/components/InfoPanel/components/AssetTitleAndDescription/components/InfoPanelDescription";
import { InfoPanelTitle } from "~/components/AssetModal/shared/components/InfoPanel/components/AssetTitleAndDescription/components/InfoPanelTitle";
export const ReadonlyAssetTitleAndDescription = /*#__PURE__*/ memo(()=>{
    return /*#__PURE__*/ _jsx(AssetTitleAndDescriptionContainer, {
        title: /*#__PURE__*/ _jsx(InfoPanelTitle, {}),
        description: /*#__PURE__*/ _jsx(InfoPanelDescription, {})
    });
});
ReadonlyAssetTitleAndDescription.displayName = "ReadonlyAssetTitleAndDescription";
